import request from 'sb-request'
import { reducers } from 'redux/core'
import { links, constants } from 'common/helpers'


const fetch = (gender) => {
  const isMale = gender === 'male'

  reducers.view.mainPage.setFetching(true)

  request.get('rest/shop/main-page-data', {
    withErrorModal: false,
    modifyResult: (result) => {
      const newStateData = Object.keys(result).reduce((data, key) => ({
        ...data, [key]: result[key],
      }), {})

      return {
        bestsellers: {
          products: newStateData.bestsellers || [],
          link: isMale ? links.bestsellersMen : links.bestsellersWomen,
          testId: constants.testIds.subscription.mainPage.bestsellers,
        },
        perfumeOfTheMonth: newStateData.perfumeOfTheMonth || [],
        cologneOfTheMonth: newStateData.cologneOfTheMonth || [],
        fragrance: {
          title: 'fragrance',
          products: newStateData.newFragrances || [],
          link: isMale ? `${links.subscription.newArrivals}?men` : links.subscription.newArrivals,
          testId: constants.testIds.subscription.mainPage.fragrances,
          isVisible: true,
        },
        newProducts: {
          title: 'newProducts',
          products: newStateData.newProducts || [],
          link: links.scentbirdProductsNew,
          testId: constants.testIds.subscription.mainPage.newProducts,
          isVisible: true,
        },
        makeup:{
          title: 'makeup',
          products: newStateData.makeup || [],
          link: links.makeup,
          testId: constants.testIds.subscription.mainPage.makeupProducts,
          isVisible: !isMale,
        },
        skincare:{
          title: 'skincare',
          products: newStateData.skincare || [],
          link: isMale ? links.fromBackend.skincareMen :  links.fromBackend.skincareWomen,
          testId: constants.testIds.subscription.mainPage.skincareProducts,
          isVisible: true,
        },
      }
    },
  })
    .then(
      (data) => reducers.view.mainPage.set(data),
      () => reducers.view.mainPage.setFetching(false)
    )
}


export default {
  fetch,
}
